



















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button } from '@/pages/profile/components';
import {
  Meeting,
  IMentoringListItem,
  MeetingStatuses,
  StyleClasses,
} from './types';
import store from '@/pages/profile/store';

@Component({
  components: {
    Button,
  },
})
export default class MentoringListItem
  extends Vue
  implements IMentoringListItem {
  @Prop({ type: Object, default: null })
  readonly item!: Meeting;

  @Prop({ type: Number, default: null })
  readonly index!: number;

  get meetingStatus() {
    const {
      $store: {
        state: { MeetingStatuses },
      },
      item: { status },
    } = this;
    const result = MeetingStatuses.find(
      ({ id }: MeetingStatuses) => id.toString() === status
    );
    return result && result.name;
  }

  get statusClass() {
    return this.item.status === '1' ? StyleClasses.GREEN : StyleClasses.RED;
  }

  openPopup(): void {
    const {
      item: { id, status },
      index,
    } = this;
    store.openMentoringPopup({ id, status, index });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/programcard/components/main/components/list/components/item/MentoringListItem.vue